export default __webpack_public_path__ + "media/images/hero-13c97d23a744cdd70c792bbb93c0f6b6.jpg";